import { render, staticRenderFns } from "./ModalCriticalConfirm.vue?vue&type=template&id=16d11c5d&"
import script from "./ModalCriticalConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalCriticalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports